
import * as Yup from 'yup';

const detalleFacturaSchema = Yup.object().shape({
  descripcion: Yup.string().required('La descripción es requerida'),
  cantidadProducto: Yup.number()
    .required('La cantidad es requerida')
    .min(0, 'La cantidad debe ser positiva')
    .max(999999.99, 'La cantidad no puede exceder 999999.99'),
  iva: Yup.number()
    .required('El IVA es requerido')
    .min(0, 'El IVA debe ser positivo')
    .max(100, 'El IVA no puede exceder el 100%'),
  descuento: Yup.number()
    .required('El descuento es requerido')
    .min(0, 'El descuento debe ser positivo')
    .max(999999.99, 'El descuento no puede exceder 999999.99'),
  importe: Yup.number()
    .required('El importe es requerido')
    .min(0, 'El importe debe ser positivo')
    .max(9999999.99, 'El importe no puede exceder 9999999.99'),
  totalEjercicio: Yup.number()
    .required('El total del ejercicio es requerido')
    .min(0, 'El total del ejercicio debe ser positivo')
    .max(9999999.99, 'El total del ejercicio no puede exceder 9999999.99'),
});

export const facturaValidationSchema = Yup.object().shape({
  ejercicioId: Yup.number().required('El ejercicio es requerido'),
  fechaFactura: Yup.date().required('La fecha de factura es requerida'),
  codigo: Yup.string()
    .required('El código es requerido')
    .matches(/^[a-zA-Z0-9-]+$/, 'El código debe ser alfanumérico y puede contener guiones')
    .min(3, 'El código debe tener al menos 3 caracteres')
    .max(50, 'El código no puede exceder los 50 caracteres'),
  fechaRegistro: Yup.date().required('La fecha de registro es requerida'),
  numero: Yup.string().required('El número es requerido'),
  descripcion: Yup.string().required('La descripción es requerida'),
  totalConIva: Yup.number()
    .required('El total con IVA es requerido')
    .min(0, 'El total con IVA debe ser positivo')
    .max(9999999.99, 'El total con IVA no puede exceder 9999999.99'),
  baseImponible: Yup.number()
    .required('La base imponible es requerida')
    .min(0, 'La base imponible debe ser positiva')
    .max(9999999.99, 'La base imponible no puede exceder 9999999.99'),
  totalDescuento: Yup.number()
    .required('El total de descuento es requerido')
    .min(0, 'El total de descuento debe ser positivo')
    .max(9999999.99, 'El total de descuento no puede exceder 9999999.99'),
  totalIva: Yup.number()
    .required('El total de IVA es requerido')
    .min(0, 'El total de IVA debe ser positivo')
    .max(9999999.99, 'El total de IVA no puede exceder 9999999.99'),
  terceroId: Yup.string().required('El tercero es requerido'),
  detallesFactura: Yup.array()
    .of(detalleFacturaSchema)
    .min(1, 'Debe haber al menos un detalle de factura'),
});

export const validateFacturaForm = async (formData) => {
  try {
    await facturaValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};